import { Divider, FormLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

const ManagementInfoContainer = styled("div")({
    margin: "20px 0",
    border: "1px solid #dbdbdb",
});

const ManagementInfoContainerHeader = styled("div")({
    padding: "10px 12px",
    marginTop: "15px",
    borderBottom: "1px solid #dbdbdb",
    textAlign: "start",
});

const StyledPersonnelContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 0",
    marginLeft: "10px",
});

const ManagementInfoContainerRow = styled("div")({
    padding: "11px 12px",
    borderTop: "none",
    "&:last-of-type": {
        marginBottom: "8px",
    },
    flex: "1 1 0",
});

const PersonnelRowDiv = styled("div")(({ personExists }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "2em",
    color: personExists ? "black" : "grey",
    fontSize: "0.875rem",
}));

const PropertyManagementInformationSnapshot = (props) => {
    const { snapshotPersonnel } = props;
    const sortPersonnelByRole = (snapshot) => {
        const personnelByRole = {};
        const result = [];
        snapshot.forEach((personnel) => {
            const { role, firstName, lastName } = personnel;

            if (role in personnelByRole) {
                personnelByRole[role].push({
                    firstName,
                    lastName,
                });
            } else {
                personnelByRole[role] = [
                    {
                        firstName,
                        lastName,
                    },
                ];
            }
        });
        for (const key in personnelByRole) {
            result.push({ role: key, personnel: personnelByRole[key] });
        }
        const col1 = result.slice(0, result.length / 2);
        const col2 = result.slice(result.length / 2, result.length);
        return [col1, col2];
    };
    return (
        <ManagementInfoContainer>
            <ManagementInfoContainerHeader>
                <div>
                    <div>
                        <h3>Management Information</h3>
                    </div>
                </div>
            </ManagementInfoContainerHeader>
            <div style={{ display: "flex" }}>
                {sortPersonnelByRole(snapshotPersonnel).map((data, index) => {
                    return (
                        <StyledPersonnelContainer key={index}>
                            {data.map((personnelData, i) => {
                                const { role, personnel } = personnelData;

                                return (
                                    <ManagementInfoContainerRow key={i}>
                                        {<FormLabel shrink>{role}</FormLabel>}
                                        {personnel.map((personData, personIndex) => {
                                            const { firstName, lastName } = personData;
                                            const personExists = firstName && lastName;
                                            return personExists ? (
                                                <PersonnelRowDiv key={personIndex}>
                                                    <p>{`${firstName} ${lastName}`}</p>
                                                </PersonnelRowDiv>
                                            ) : (
                                                <PersonnelRowDiv key={personIndex} personExists={personExists}>
                                                    <p>No individual found</p>
                                                </PersonnelRowDiv>
                                            );
                                        })}
                                        <Divider />
                                    </ManagementInfoContainerRow>
                                );
                            })}
                        </StyledPersonnelContainer>
                    );
                })}
            </div>
        </ManagementInfoContainer>
    );
};

export default PropertyManagementInformationSnapshot;
